module.exports = __webpack_public_path__ + "img/gina_1x1.e387bacc.webp";